// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1LZbO","head":"ProcedureTableInfo_head__2jCL1"};